var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.7182 19.028L35.0013 0L2.23393 19.0559L14.4241 26.0949C18.9983 19.6642 26.5106 15.4695 35.0024 15.4695C43.4761 15.4695 50.9743 19.6462 55.5512 26.0535L67.7182 19.028Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.4069L11.9911 30.3309C10.5613 33.4967 9.76553 37.0103 9.76553 40.7097C9.76553 53.825 19.7673 64.6039 32.5586 65.8332V79.9997L0 61.0651V23.4069Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4432 80V65.8335C50.2359 64.6056 60.2393 53.826 60.2393 40.7097C60.2393 36.9922 59.4357 33.4624 57.9928 30.2846L70 23.3513V61.0651L37.4432 80Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9984 54.9591C41.8188 54.9591 47.5197 50.1658 48.9172 43.7636H42.5484C41.3407 46.7475 38.4157 48.8524 34.9992 48.8524C30.5031 48.8524 26.8582 45.2071 26.8582 40.7104C26.8582 36.2137 30.5031 32.5683 34.9992 32.5683C38.4157 32.5683 41.3407 34.6732 42.5484 37.6571H48.9171C47.5195 31.2552 41.8186 26.462 34.9984 26.462C27.1302 26.462 20.7518 32.8413 20.7518 40.7106C20.7518 48.5798 27.1302 54.9591 34.9984 54.9591Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0008 61.0653C46.241 61.0653 55.3531 51.9521 55.3531 40.7103C55.3531 29.4685 46.241 20.3552 35.0008 20.3552C23.7605 20.3552 14.6484 29.4685 14.6484 40.7103C14.6484 51.9521 23.7605 61.0653 35.0008 61.0653ZM34.9985 54.959C41.8189 54.959 47.5199 50.1657 48.9173 43.7635H42.5485C41.3408 46.7474 38.4158 48.8523 34.9993 48.8523C30.5032 48.8523 26.8584 45.207 26.8584 40.7103C26.8584 36.2136 30.5032 32.5683 34.9993 32.5683C38.4158 32.5683 41.3408 34.6731 42.5485 37.657H48.9172C47.5196 31.2551 41.8188 26.4619 34.9985 26.4619C27.1303 26.4619 20.7519 32.8412 20.7519 40.7105C20.7519 48.5797 27.1303 54.959 34.9985 54.959Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.214ce792.svg";
export { ForwardRef as ReactComponent };